import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import mixpanel from 'mixpanel-browser';

mixpanel.init('7ba03b11dc73e1c8f93e64e79bc865b5', { track_pageview: true, autocapture: true, record_sessions_percent: 100, persistence: 'localStorage' });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
